// extracted by mini-css-extract-plugin
module.exports = {"w1jngkvq":"w1jngkvq"};